import React from 'react';
import { NavLink } from 'react-router-dom';
import './AdminSidebar.css';
import { brand } from '../../branding';
import UNCLogo from '../../images/UNCLogo.png';

function AdminSidebar({ username, firstName, lastName, isTeacher, onLogout }) {
  const displayName = firstName && lastName ? `${firstName} ${lastName}` : username;

  return (
    <div className="sidebar admin-sidebar">
      <div className="sidebar-title">
        <div className="sidebar-logo">
          {/* Back to this site's home, whichever brand it is */}
          <a href="/">
            <img src={brand.sidebarLogo} alt={`${brand.name} Logo`} />
          </a>
        </div>
        <div className="sidebar-title-text">
          <span className="title-name">{brand.name}</span>
          <span className="title-subname">Admin Dashboard</span>
        </div>
      </div>

      <div className="admin-nav">
        <p className="admin-nav-label">Navigation</p>
        <NavLink to="/" className={({ isActive }) => isActive ? 'admin-nav-item admin-nav-item-active' : 'admin-nav-item'} end>
          Overview
        </NavLink>
        <NavLink to="/admin/cases" className={({ isActive }) => isActive ? 'admin-nav-item admin-nav-item-active' : 'admin-nav-item'}>
          Simulation Cases
        </NavLink>
        <NavLink to="/admin/classes" className={({ isActive }) => isActive ? 'admin-nav-item admin-nav-item-active' : 'admin-nav-item'}>
          Classes
        </NavLink>
        <NavLink to="/admin/students" className={({ isActive }) => isActive ? 'admin-nav-item admin-nav-item-active' : 'admin-nav-item'}>
          Students
        </NavLink>
        {!isTeacher && (
          <NavLink to="/admin/teachers" className={({ isActive }) => isActive ? 'admin-nav-item admin-nav-item-active' : 'admin-nav-item'}>
            Teachers
          </NavLink>
        )}
        {!isTeacher && (
          <NavLink to="/admin/admins" className={({ isActive }) => isActive ? 'admin-nav-item admin-nav-item-active' : 'admin-nav-item'}>
            Admins
          </NavLink>
        )}
      </div>

      <NavLink to="/admin/profile" className="sidebar-profile">
        <img className="admin-avatar" src={UNCLogo} alt={displayName} />
        <div className="profile-text">
          <span className="profile-name">{displayName}</span>
        </div>
      </NavLink>

      <div className="sidebar-logout">
        <button className="logout-button" onClick={onLogout}>
          Logout
        </button>
      </div>
    </div>
  );
}

export default AdminSidebar;
